import { render, staticRenderFns } from "./SplitBill.vue?vue&type=template&id=e5ef4370&scoped=true"
import script from "./SplitBill.vue?vue&type=script&lang=js"
export * from "./SplitBill.vue?vue&type=script&lang=js"
import style0 from "./SplitBill.vue?vue&type=style&index=0&id=e5ef4370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ef4370",
  null
  
)

export default component.exports